import { gql, TypedDocumentNode } from '@apollo/client'
import { workPostSheetItemFragment } from './WorkPostSheetItemFragment'
import type { WorkPostSheetFragment } from './__generated__/WorkPostSheetFragment'

export const workPostSheetFragment: TypedDocumentNode<WorkPostSheetFragment> = gql`
  ${workPostSheetItemFragment}

  fragment WorkPostSheetFragment on WorkPostSheet {
    foreseeableTraining
    id
    items {
      ...WorkPostSheetItemFragment
    }
    priorInstructions
    requiredQualifications
    welcomeOfficer
    welcomeOfficerPosition
    tasksToPerform
    workEquipment
    workstationLocation
  }
`
